import { render, staticRenderFns } from "./componetPlayground.vue?vue&type=template&id=a863c908&scoped=true&"
import script from "./componetPlayground.vue?vue&type=script&lang=js&"
export * from "./componetPlayground.vue?vue&type=script&lang=js&"
import style0 from "./componetPlayground.vue?vue&type=style&index=0&id=a863c908&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a863c908",
  null
  
)

export default component.exports